import styled from "styled-components";

export const Section = styled.section`
  padding-top: 4rem;
  padding-bottom: 4rem;
  background-color: white;
  margin-bottom: 4rem;

  @media (min-width: 768px) {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }
`;

export const Container = styled.div`
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;

  @media (min-width: 640px) {
    max-width: 640px;
  }

  @media (min-width: 768px) {
    max-width: 768px;
  }

  @media (min-width: 1024px) {
    max-width: 1024px;
  }

  @media (min-width: 1280px) {
    max-width: 1280px;
  }

  @media (min-width: 1536px) {
    max-width: 1536px;
  }
`;

export const Header = styled.div`
  max-width: 48rem;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 4rem;
`;

export const Tag = styled.span`
  display: inline-block;
  padding: 0.25rem 0.75rem;
  background-color: #e0f2fe;
  color: ${({ theme }) => theme.colors.primary[3]};
  border-radius: 9999px;
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 1rem;
`;

export const Title = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primaryText[9]};
  margin-bottom: 1.5rem;

  @media (min-width: 768px) {
    font-size: 2.25rem;
  }
`;

export const Description = styled.p`
  font-size: 1.125rem;
  color: #4b5563;
`;

export const Grid = styled.div`
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
`;

export const Card = styled.div`
  background-color: #f9fafb;
  border-radius: 1rem;
  padding: 2rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    transform: translateY(-4px);
  }
`;

export const Stars = styled.div`
  display: flex;
  gap: 0.25rem;
  margin-bottom: 1.5rem;
`;

export const ContentContainer = styled.div`
  height: 85%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Content = styled.p`
  color: ${({ theme }) => theme.colors.primaryText[9]};
  font-size: 1rem;
  margin-bottom: 1.5rem;
`;

export const AuthorContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const Avatar = styled.img`
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  object-fit: cover;
`;

export const AuthorDetails = styled.div`
  h3 {
    font-size: 1rem;
    font-weight: 600;
    margin: 0;
    color: ${({ theme }) => theme.colors.primaryText[9]};
  }
  p {
    font-size: 0.875rem;
    margin: 0;
    color: ${({ theme }) => theme.colors.primaryText[9]};
  }
`;
